// Small pieces the Expenses page and its modals share.
import { ChevronLeft, ChevronRight, Loader2 } from "lucide-react";

export const KIND_PILL = {
  general: "bg-vaulzo-accent-tint text-vaulzo-accent",
  group: "bg-vaulzo-group-bg text-vaulzo-group-fg",
  single: "bg-vaulzo-row text-vaulzo-muted",
};

export function Pill({ tone = "single", children }) {
  return (
    <span className={`whitespace-nowrap rounded-full px-[10px] py-[3px] text-[12px] font-semibold ${KIND_PILL[tone]}`}>
      {children}
    </span>
  );
}

/** Round arrow button (year and month switches). */
export function ArrowButton({ dir, onClick, disabled = false, label }) {
  const Icon = dir === "left" ? ChevronLeft : ChevronRight;
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      className="flex h-9 w-9 flex-none items-center justify-center rounded-full border border-vaulzo-chip bg-vaulzo-surface text-vaulzo-ink transition-colors hover:bg-vaulzo-row disabled:text-vaulzo-input-line disabled:hover:bg-vaulzo-surface"
    >
      <Icon className="h-4 w-4" strokeWidth={2} />
    </button>
  );
}

/** Round icon button: `tone` "primary" (accent fill) or "soft" (white, hairline). */
export function RoundButton({ onClick, label, tone = "soft", size = 40, children, disabled = false }) {
  const cls =
    tone === "primary"
      ? "bg-vaulzo-accent text-vaulzo-on-fill hover:bg-vaulzo-accent-hover"
      : "border border-vaulzo-chip bg-vaulzo-surface text-vaulzo-muted hover:bg-vaulzo-row";
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      title={label}
      disabled={disabled}
      style={{ width: size, height: size }}
      className={`flex flex-none items-center justify-center rounded-full transition-colors disabled:opacity-50 ${cls}`}
    >
      {children}
    </button>
  );
}

export const kicker = "mb-[14px] text-[12px] uppercase tracking-[0.14em] text-vaulzo-fainter";
export const fieldLabel = "mb-[10px] block text-[13px] font-semibold text-vaulzo-muted";
export const underline =
  "w-full border-0 border-b-[1.5px] border-vaulzo-input-line bg-transparent py-2 text-vaulzo-ink outline-none transition-colors placeholder:text-vaulzo-subtle focus:border-vaulzo-accent";

export function PrimaryButton({ children, busy = false, disabled = false, onClick, type = "submit", small = false }) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || busy}
      className={`flex items-center justify-center rounded-[11px] bg-vaulzo-accent font-semibold text-vaulzo-on-fill transition-colors hover:bg-vaulzo-accent-hover disabled:opacity-60 ${
        small ? "px-[16px] py-[10px] text-[14px]" : "px-[30px] py-[14px] text-[15px]"
      }`}
    >
      {busy ? <Loader2 className="h-4 w-4 animate-spin" aria-hidden /> : children}
    </button>
  );
}

export function SoftButton({ children, onClick, disabled = false, small = false }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`rounded-[11px] bg-vaulzo-row font-semibold text-vaulzo-muted transition-colors hover:bg-vaulzo-soft disabled:opacity-50 ${
        small ? "px-[16px] py-[10px] text-[14px]" : "px-[26px] py-[14px] text-[15px]"
      }`}
    >
      {children}
    </button>
  );
}
